// src/api/requestLogApi.js
import apiClient from "./axios";

const requestLogApi = {
  getAll: async (page = 1, pageSize = 20, search = "", request = "") => {
    const response = await apiClient.get("/request-logs/", {
      params: {
        page,
        page_size: pageSize,
        search: search.trim() || undefined,
        request: request || undefined,
      },
    });
    return response.data;
  },
};

export default requestLogApi;
